import {
  summaryDownloadHotEventData,
  getSummaryHotEventListV2,
} from '@op/services';
import { languageRenderHelper } from '../renderHelper';
import { DownloadConfigInfoType } from '../types';
import { getDatabrainUrlRender, fetchAllPages } from '../utils';
import { hideSentimentFunc } from '@op/components/DownloadCommon/download-page/render-helper';

export const HotEventDataDownload: DownloadConfigInfoType = {
  type: 'zip',
  files: [
    {
      type: 'xlsx',
      key: 'excel_data',
      fileName: 'HotEvent EventList English',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: [
        { key: 'overview', header: 'overview' },
        { key: 'opinion', header: 'opinion' },
        { key: 'mentions', header: 'mentions' },
      ],
    },
    {
      type: 'xlsx',
      key: 'excel_data',
      fileName: 'HotEvent EventList Chinese',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_events',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: [
        { key: 'overview_zh', header: 'overview' },
        { key: 'opinion_zh', header: 'opinion' },
        { key: 'mentions', header: 'mentions' },
      ],
    },
    {
      type: 'xlsx',
      key: 'excel_data',
      fileName: 'HotEvent EventReviews English',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: ({ filter }) => {
        return [
          { key: 'opinion', header: 'opinion' },
          { key: 'overview', header: 'overview' },
          { key: 'content', header: 'content' },
          { key: 'content_to_en', header: 'content_to_en' },
          {
            key: 'sentiment_rating',
            header: 'sentiment_rating',
            renderHelper: [hideSentimentFunc],
          },
          { key: 'comment_time', header: 'comment_time' },
          { key: 'topics', header: 'topics' },
          { key: 'channel_name', header: 'channel_name' },
          {
            key: 'language',
            header: 'language',
            renderHelper: [languageRenderHelper],
          },
          { key: 'content_url', header: 'content_url' },
          {
            key: 'databrain_url',
            header: 'databrain_url',
            renderHelper: [getDatabrainUrlRender(filter.edition_unified_id)],
          },
          { key: 'engagement', header: 'engagement' },
        ];
      },
    },
    {
      type: 'xlsx',
      key: 'excel_data',
      fileName: 'HotEvent EventReviews Chinese',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: ({ filter }) => {
        return [
          { key: 'opinion_zh', header: 'opinion' },
          { key: 'overview_zh', header: 'overview' },
          { key: 'content', header: 'content' },
          { key: 'content_to_zh', header: 'content_to_zh' },
          {
            key: 'sentiment_rating',
            header: 'sentiment_rating',
            renderHelper: [hideSentimentFunc],
          },
          { key: 'comment_time', header: 'comment_time' },
          { key: 'topics', header: 'topics' },
          { key: 'channel_name', header: 'channel_name' },
          {
            key: 'language',
            header: 'language',
            renderHelper: [languageRenderHelper],
          },
          { key: 'content_url', header: 'content_url' },
          {
            key: 'databrain_url',
            header: 'databrain_url',
            renderHelper: [getDatabrainUrlRender(filter.edition_unified_id)],
          },
          { key: 'engagement', header: 'engagement' },
        ];
      },
    },
  ],
  customizeDownloadFunc: async ({ filter }) => {
    try {
      const excelData = await summaryDownloadHotEventData(filter);
      return {
        excel_data: excelData,
        status: 'success',
      };
    } catch (error) {
      return {
        tips: {
          excel_data: 'failed',
        },
      };
    }
  },
};

/**
 * 列表数据下载 — zip 包内含中文/英文两个 xlsx
 * 分页拉取 getSummaryHotEventListV2 全部数据
 */
export const HotEventDataListDownload: DownloadConfigInfoType = {
  type: 'zip',
  files: [
    // ─── 列表数据 ───
    {
      type: 'xlsx',
      key: 'list_data',
      fileName: 'HotEvent List English',
      sheetNames: 'HotEvent_List_EN',
      columns: [
        { key: 'event_title', header: 'Event Title' },
        { key: 'event_title_en', header: 'Event Title (EN)' },
        { key: 'event_gpt_content', header: 'GPT Summary' },
        { key: 'event_gpt_content_en', header: 'GPT Summary (EN)' },
        { key: 'avg_sentiment', header: 'Avg Sentiment' },
        { key: 'data_sentiment', header: 'Sentiment' },
        { key: 'mentions', header: 'Mentions' },
        { key: 'total_comments', header: 'Total Comments' },
        { key: 'post_count', header: 'Post Count' },
        { key: 'comment_count', header: 'Comment Count' },
        { key: 'unique_reviewers', header: 'Unique Reviewers' },
        { key: 'total_engagement', header: 'Engagement' },
        { key: 'total_likes', header: 'Likes' },
        { key: 'important_score', header: 'Importance' },
      ],
    },
    {
      type: 'xlsx',
      key: 'list_data',
      fileName: 'HotEvent List Chinese',
      sheetNames: 'HotEvent_List_CN',
      columns: [
        { key: 'event_title', header: 'Event Title' },
        { key: 'event_title_cn', header: 'Event Title (CN)' },
        { key: 'event_gpt_content', header: 'GPT Summary' },
        { key: 'event_gpt_content_cn', header: 'GPT Summary (CN)' },
        { key: 'avg_sentiment', header: 'Avg Sentiment' },
        // { key: 'data_sentiment', header: 'Sentiment' },
        { key: 'mentions', header: 'Mentions' },
        { key: 'total_comments', header: 'Total Comments' },
        { key: 'post_count', header: 'Post Count' },
        { key: 'comment_count', header: 'Comment Count' },
        { key: 'unique_reviewers', header: 'Unique Reviewers' },
        { key: 'total_engagement', header: 'Engagement' },
        { key: 'total_likes', header: 'Likes' },
        // { key: 'important_score', header: 'Importance' },
      ],
    },
    // ─── EventReviews 数据（按情感分组） ───
    {
      type: 'xlsx',
      key: 'reviews_data',
      fileName: 'HotEvent EventReviews English',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: ({ filter }) => [
        { key: 'opinion', header: 'opinion' },
        { key: 'overview', header: 'overview' },
        { key: 'content', header: 'content' },
        { key: 'content_to_en', header: 'content_to_en' },
        { key: 'sentiment_rating', header: 'sentiment_rating' },
        { key: 'comment_time', header: 'comment_time' },
        { key: 'topics', header: 'topics' },
        { key: 'channel_name', header: 'channel_name' },
        {
          key: 'language',
          header: 'language',
          renderHelper: [languageRenderHelper],
        },
        { key: 'content_url', header: 'content_url' },
        {
          key: 'databrain_url',
          header: 'databrain_url',
          renderHelper: [getDatabrainUrlRender(filter.edition_unified_id)],
        },
        { key: 'engagement', header: 'engagement' },
      ],
    },
    {
      type: 'xlsx',
      key: 'reviews_data',
      fileName: 'HotEvent EventReviews Chinese',
      sheetNames: [
        {
          name: 'POS',
          key: 'positive_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEG',
          key: 'negative_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
        {
          name: 'NEUTRAL',
          key: 'neutral_feeds',
          addOn: '',
          replaceName: '',
          hideNoData: true,
        },
      ],
      columns: ({ filter }) => [
        { key: 'opinion_zh', header: 'opinion' },
        { key: 'overview_zh', header: 'overview' },
        { key: 'content', header: 'content' },
        { key: 'content_to_zh', header: 'content_to_zh' },
        { key: 'sentiment_rating', header: 'sentiment_rating' },
        { key: 'comment_time', header: 'comment_time' },
        { key: 'topics', header: 'topics' },
        { key: 'channel_name', header: 'channel_name' },
        {
          key: 'language',
          header: 'language',
          renderHelper: [languageRenderHelper],
        },
        { key: 'content_url', header: 'content_url' },
        {
          key: 'databrain_url',
          header: 'databrain_url',
          renderHelper: [getDatabrainUrlRender(filter.edition_unified_id)],
        },
        { key: 'engagement', header: 'engagement' },
      ],
    },
  ],
  customizeDownloadFunc: async ({ filter }) => {
    try {
      const allData = await fetchAllPages(getSummaryHotEventListV2, {
        ...filter,
        view_mode: 'list',
      });
      const reviewsData = await fetchAllPages(getSummaryHotEventListV2, {
        ...filter,
        view_mode: 'feeds_comments',
      });

      // 按情感分组（sentiment_rating 为字符串: "Positive" / "Negative" / "Neutral"）
      const grouped: Record<string, any[]> = {
        positive_feeds: [],
        negative_feeds: [],
        neutral_feeds: [],
      };
      reviewsData.forEach((item: any) => {
        const rating = item?.sentiment_rating as string | undefined;
        let key: string;
        if (rating === 'Positive') {
          key = 'positive_feeds';
        } else if (rating === 'Negative') {
          key = 'negative_feeds';
        } else {
          key = 'neutral_feeds';
        }
        grouped[key].push(item);
      });

      return { list_data: allData, reviews_data: grouped };
    } catch (error) {
      return {
        list_data: [],
        reviews_data: {
          positive_feeds: [],
          negative_feeds: [],
          neutral_feeds: [],
        },
      };
    }
  },
};
